/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QuestLeaderboardProfileAllOf,
    QuestLeaderboardProfileAllOfFromJSON,
    QuestLeaderboardProfileAllOfFromJSONTyped,
    QuestLeaderboardProfileAllOfToJSON,
    QuestProgression,
    QuestProgressionFromJSON,
    QuestProgressionFromJSONTyped,
    QuestProgressionToJSON,
    QuestProgressionMilestone,
    QuestProgressionMilestoneFromJSON,
    QuestProgressionMilestoneFromJSONTyped,
    QuestProgressionMilestoneToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuestLeaderboardProfile
 */
export interface QuestLeaderboardProfile extends QuestProgression {
    /**
     * 
     * @type {string}
     * @memberof QuestLeaderboardProfile
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestLeaderboardProfile
     */
    gravatar?: string;
}

export function QuestLeaderboardProfileFromJSON(json: any): QuestLeaderboardProfile {
    return QuestLeaderboardProfileFromJSONTyped(json, false);
}

export function QuestLeaderboardProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestLeaderboardProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...QuestProgressionFromJSONTyped(json, ignoreDiscriminator),
        'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
        'gravatar': !exists(json, 'gravatar') ? undefined : json['gravatar'],
    };
}

export function QuestLeaderboardProfileToJSON(value?: QuestLeaderboardProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...QuestProgressionToJSON(value),
        'nickname': value.nickname,
        'gravatar': value.gravatar,
    };
}


